import React from 'react';
import { Badge, Table } from 'react-bootstrap';
import { money } from '../lib/describe';
import { sameRate } from '../lib/previewRule';
import { dateTime } from './Common';
import BrandIcon from './BrandIcon';
import { carrierIconFor } from '../config/brandIcons';

const RatesTable = ({ rates = [], winner }) => (
  <div className="table-responsive">
    <Table size="sm" className="small align-middle">
      <thead>
        <tr>
          <th>Group</th>
          <th>Carrier / service</th>
          <th>Package</th>
          <th>Total</th>
          <th>Shipping</th>
          <th>Delivery</th>
          <th>Zone</th>
        </tr>
      </thead>
      <tbody>
        {[...rates]
          .sort((a, b) => a.total - b.total)
          .map((rate, i) => (
            <tr
              key={i}
              className={sameRate(rate, winner) ? 'table-success' : ''}
            >
              <td>{rate.group || '—'}</td>
              <td className="text-break">
                <span className="d-inline-flex align-items-center gap-2">
                  <BrandIcon
                    src={carrierIconFor(rate.carrierCode)}
                    alt={rate.carrierCode || rate.carrierId || 'Carrier'}
                  />
                  <span>{rate.carrierCode || rate.carrierId}</span>
                </span>
                <div>{rate.serviceCode}</div>
                {sameRate(rate, winner) && <Badge bg="success">Winner</Badge>}
              </td>
              <td className="text-break">{rate.packageType || '—'}</td>
              <td className="text-nowrap">{money(rate.total)}</td>
              <td>{money(rate.shipping)}</td>
              <td>
                {rate.deliveryDays != null ? `${rate.deliveryDays} days` : '—'}
                {rate.estimatedDelivery && (
                  <div>{dateTime(rate.estimatedDelivery)}</div>
                )}
              </td>
              <td>{rate.zone ?? '—'}</td>
            </tr>
          ))}
        {!rates.length && (
          <tr>
            <td colSpan={7} className="text-muted text-center py-3">
              No rates recorded.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default RatesTable;
